import { Dialog } from "@material-ui/core";

export type { DialogProps } from "@material-ui/core";

export default Dialog;
